/**
 * Compliance Risk Service
 * Handles compliance, fraud and risk report data fetching
 */

import { IS_MOCK, MOCK_DELAY } from '../../constants/config';
import { generateMockComplianceRiskData } from '../mock/mockComplianceRisk';
import { delay } from '../mock/mockData';
import type { ComplianceRiskData, ReportFilters } from '../../types/reports';

class ComplianceRiskService {
  /**
   * Get compliance risk report data
   */
  static async getComplianceRiskData(
    filters?: ReportFilters
  ): Promise<ComplianceRiskData> {
    if (IS_MOCK) {
      await delay(MOCK_DELAY / 2);
      return generateMockComplianceRiskData();
    } else {
      const params = new URLSearchParams();
      
      if (filters?.dateRange) params.append('dateRange', filters.dateRange);
      if (filters?.region) params.append('region', filters.region);
      
      const response = await fetch(`/api/reports/compliance-risk?${params.toString()}`);
      if (!response.ok) {
        throw new Error('Failed to fetch compliance risk data');
      }
      return response.json();
    }
  }
}

export { ComplianceRiskService };

